var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartyPopperIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 47.939,
    viewBox: "0 0 48 47.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4I9SHw.tif",
    "data-name": "4I9SHw.tif",
    transform: "translate(24 23.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4I9SHw.tif-2",
    "data-name": "4I9SHw.tif",
    transform: "translate(-24 -23.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48312",
    "data-name": "Group 48312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140751",
    "data-name": "Path 140751",
    d: "M142.969,2.6a22.2,22.2,0,0,0-3.772.377c-1.524.4-1.807.932-1.225,2.41.191.485.485.93.693,1.409.954,2.2-.186,3.881-2.58,3.806a42.6,42.6,0,0,1-5.109-.853,3.11,3.11,0,0,0-1.155-.057,2.584,2.584,0,0,0,.606,1.282c.427.642.906,1.252,1.307,1.91a3.249,3.249,0,0,1-1.332,4.861,20.507,20.507,0,0,1-5.026,1.549,9.608,9.608,0,0,0-2.137.553c-.331.062-.666.11-.994.189a24.172,24.172,0,0,0-5.222,2.089l-.151-.156c.068-.1.131-.207.2-.3A15.837,15.837,0,0,1,121.5,18.1a59.052,59.052,0,0,1,6.9-2.379c1.428-.429,1.52-.857.635-2.107a11.462,11.462,0,0,1-1.827-3.1c-.66-2.1.335-3.487,2.536-3.525,1.938-.034,3.77.624,5.664.879.24.032.482.058.8.1a16.669,16.669,0,0,1-1.089-2.792A3.568,3.568,0,0,1,137.167.9a12.308,12.308,0,0,1,5.8-.893Z",
    transform: "translate(-95.05 0)",
    fill: "#ff740a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140752",
    "data-name": "Path 140752",
    d: "M152.2,215.748a3.949,3.949,0,0,1-2.279-3.229c-.068-.666.148-.826.739-.764a5.452,5.452,0,0,0,.834,0c.6-.028,1.2-.1,1.159.815a.4.4,0,0,0,.3.421c.263.046.375-.181.493-.35a30.7,30.7,0,0,0,1.839-3.315,18.277,18.277,0,0,1,1.134-2.011,1.809,1.809,0,0,1,3.191.159,11.429,11.429,0,0,1,1.107,3.7c.085.382.157.767.24,1.175.391-.143.528-.478.758-.713.41-.419.781-.882,1.225-1.261,2.657-2.27,5.277-1.513,6.352,1.8a8.007,8.007,0,0,0,.541,1.9c0,.556.217,1.33-.061,1.608s-1.053.061-1.61.061h-.928c-.1-.64-.146-1.29-.3-1.917-.175-.728-.145-1.757-.951-1.968-.882-.23-1.466.639-2.02,1.251a11.677,11.677,0,0,1-2.672,2.634h-1.114a3.012,3.012,0,0,1-1.659-2.2c-.258-.994-.462-2-.727-3.169-1.219,2.062-1.927,4.293-4.112,5.37Z",
    transform: "translate(-121.917 -167.89)",
    fill: "#e74973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140753",
    "data-name": "Path 140753",
    d: "M143.123,121.887a26.235,26.235,0,0,1,7.311-.827,17.408,17.408,0,0,1,5.052.992,6.9,6.9,0,0,1,4.644,4.579v1.113a5.891,5.891,0,0,0-.735-.038c-1.044.072-1.948.164-2.318-1.273-.257-1-1.379-1.436-2.339-1.8a15.441,15.441,0,0,0-5.611-.934c-1.6.012-3.2.143-4.792.221-2.136.09-4.229.539-6.36.8a5.379,5.379,0,0,1,.854-.711A24.468,24.468,0,0,1,143.123,121.887Z",
    transform: "translate(-112.21 -98.433)",
    fill: "#008dd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140754",
    "data-name": "Path 140754",
    d: "M234.016,181.771c-.752.722-1.516,1.433-2.249,2.173-.3.306-.511.335-.82,0-.61-.653-1.247-1.282-1.9-1.9-.293-.277-.317-.5,0-.743a.8.8,0,0,0,.065-.066c.73-.706,1.4-1.873,2.208-1.983.767-.1,1.4,1.213,2.131,1.857.182.159.37.312.554.468Z",
    transform: "translate(-186.097 -145.783)",
    fill: "#ff740a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140755",
    "data-name": "Path 140755",
    d: "M240.62,81.028c-.554.528-1.12,1.042-1.655,1.588-.248.253-.394.248-.673.017-1.784-1.484-1.788-1.7-.068-3.29.309-.285.482-.358.8-.012.5.536,1.059,1.01,1.593,1.511Z",
    transform: "translate(-192.7 -64.33)",
    fill: "#e74973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140756",
    "data-name": "Path 140756",
    d: "M67.013,240.424c-.467-.484-.912-.993-1.409-1.443-.413-.374-.508-.617-.044-1.076,1.514-1.5,1.468-1.5,2.972-.023.491.481.406.727-.039,1.143a5.329,5.329,0,0,0-1.294,1.4Z",
    transform: "translate(-53.067 -192.566)",
    fill: "#008dd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140757",
    "data-name": "Path 140757",
    d: "M31.825,136.062c-2.108,1.089-4.337,1.9-6.517,2.828q-11.874,5.038-23.765,10.038c-.3.127-.579.364-.947.281.034-.485.46-.7.679-1.054.228-.033.395-.12.349-.395l-.006.007c.351.031.444-.265.621-.471q2.975-3.473,5.961-6.937c2.1-2.454,4.173-4.941,6.316-7.361,1.448-1.635,2.748-3.4,4.34-4.909a32.971,32.971,0,0,0,6.946,5.906A11.249,11.249,0,0,0,31.825,136.062Z",
    transform: "translate(-0.485 -104.171)",
    fill: "#ffc627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140758",
    "data-name": "Path 140758",
    d: "M89.5,84.1a11.249,11.249,0,0,1-6.022-2.068,32.977,32.977,0,0,1-6.946-5.906,53.694,53.694,0,0,1-3.288-4.441c-.911-1.792-1.838-3.579-1.719-5.681A2.211,2.211,0,0,1,74.05,64.2a8.832,8.832,0,0,1,3.859,1.165,52.249,52.249,0,0,1-.81,5.324,7.364,7.364,0,0,0,1.232-1.249,13.8,13.8,0,0,0,1.777-2.777,26.045,26.045,0,0,1,4.5,3.652,15.851,15.851,0,0,0-4.419,3.562c-.073.1-.136.2-.2.305-.065.074-.263.1-.148.239.082.1.221.03.3-.084a24.172,24.172,0,0,1,5.222-2.089c.327-.08.662-.127.994-.189a33.853,33.853,0,0,1,2.723,3.606,24.5,24.5,0,0,0-4.3,2.126,5.377,5.377,0,0,0-.854.711c2.132-.263,4.224-.712,6.36-.8a9.7,9.7,0,0,1,1.138,3.827A2.208,2.208,0,0,1,89.5,84.1Z",
    transform: "translate(-58.161 -52.212)",
    fill: "#53342e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140759",
    "data-name": "Path 140759",
    d: "M6.421,14.743a15.266,15.266,0,0,1-3.924-.39,3.184,3.184,0,0,1-2.168-1.6,2.629,2.629,0,0,1,.911-3.511c.713-.513,1.518-.9,2.351-1.379-.661-.4-1.282-.731-1.849-1.135A3.667,3.667,0,0,1,.109,2.792,3.614,3.614,0,0,1,3.24.147c.6-.133.872.03.8.68a5.334,5.334,0,0,0,0,1.019c.041.539-.018.9-.693,1.053-.759.172-.878.95-.253,1.49a8.954,8.954,0,0,0,1.4.887,6.355,6.355,0,0,1,1.374.936A2.2,2.2,0,0,1,5.5,9.889c-.727.462-1.526.808-2.284,1.222-.175.1-.455.175-.39.44.046.185.288.2.468.246a12.048,12.048,0,0,0,2.673.233c1.376.065,2.768.238,3.248,1.775.457,1.462-.5,2.466-1.517,3.321a16.594,16.594,0,0,1-4.956,2.657c-.086.032-.212.122-.252.093-.673-.5-.587-1.352-.935-2.007-.217-.409.111-.528.413-.643A14.333,14.333,0,0,0,6.421,14.743Z",
    transform: "translate(0 -0.084)",
    fill: "#ff740a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140760",
    "data-name": "Path 140760",
    d: "M16.21,73.882c-.118,2.1.808,3.889,1.719,5.681-3.7,6.325-7.407,12.64-11.075,18.98a46.286,46.286,0,0,0-2.874,5.138l.006-.007-.394.21c-.1-.048-.108-.125-.068-.218Q9.809,88.844,16.1,74.021A.634.634,0,0,1,16.21,73.882Z",
    transform: "translate(-2.847 -60.086)",
    fill: "#ffc627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140761",
    "data-name": "Path 140761",
    d: "M85.773,25.948A13.8,13.8,0,0,1,84,28.725a7.364,7.364,0,0,1-1.232,1.249,52.25,52.25,0,0,0,.81-5.324,10.252,10.252,0,0,0,.049-4.127,4.473,4.473,0,0,0-4.35-3.629c-.655-.057-.8-.276-.793-.89.015-2.1-.012-2.081,2.066-1.613,4.427,1,6.263,4.621,5.871,8.771A17.361,17.361,0,0,1,85.773,25.948Z",
    transform: "translate(-63.825 -11.496)",
    fill: "#e74973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140762",
    "data-name": "Path 140762",
    d: "M117.379,212.317c-.139-.122-.256-.216-.362-.321-.635-.632-1.25-1.287-1.909-1.891-.353-.323-.277-.521.027-.808.629-.593,1.24-1.207,1.835-1.835.278-.293.474-.409.809-.046.627.681,1.3,1.321,1.962,1.971.2.2.309.353.048.6-.712.685-1.4,1.394-2.1,2.09A3.376,3.376,0,0,1,117.379,212.317Z",
    transform: "translate(-93.424 -168.502)",
    fill: "#e74973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140763",
    "data-name": "Path 140763",
    d: "M124.238,4.76c-.267-.334-.51-.7-.81-1-1.028-1.051-1.036-1.043.017-2.1A4.171,4.171,0,0,0,123.9,1.2c.347-.477.611-.375,1,.007,1.622,1.6,1.619,1.835-.208,3.215Z",
    transform: "translate(-99.753 -0.717)",
    fill: "#008dd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140764",
    "data-name": "Path 140764",
    d: "M140.932,45.821a14.5,14.5,0,0,0-1.321.977c-1.049,1.015-1.039,1.025-2.054.011-.989-.988-.989-.988.01-1.986s.988-.987,2.052.041A13.551,13.551,0,0,0,140.932,45.821Z",
    transform: "translate(-111.269 -35.852)",
    fill: "#ff740a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140765",
    "data-name": "Path 140765",
    d: "M48.484,3.143a9,9,0,0,0-1.325,1.12c-.607.773-1.042.7-1.682-.005-1.107-1.223-1.1-1.138.028-2.4.641-.716,1.049-.706,1.619.015A13.176,13.176,0,0,0,48.484,3.143Z",
    transform: "translate(-36.316 -1.079)",
    fill: "#ffd639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140766",
    "data-name": "Path 140766",
    d: "M2.468,133.352c-.222-.281-.456-.6-.718-.9a8.817,8.817,0,0,0-.777-.783c-.274-.243-.264-.445.018-.659a1.141,1.141,0,0,0,.128-.132c1.61-1.689,1.706-1.684,3.2.15.136.166.34.3.111.534q-.778.784-1.564,1.56A2.7,2.7,0,0,1,2.468,133.352Z",
    transform: "translate(-0.629 -105.425)",
    fill: "#008dd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140767",
    "data-name": "Path 140767",
    d: "M203.093,155.249a10.66,10.66,0,0,0,.787,1.068c1.167,1.192,1.129,1.145.028,2.365-.628.7-1.006.754-1.662.023-1.116-1.245-1.161-1.2.06-2.431A12.283,12.283,0,0,0,203.093,155.249Z",
    transform: "translate(-163.792 -126.26)",
    fill: "#ffd639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140768",
    "data-name": "Path 140768",
    d: "M3.988,233.646l.394-.21c.046.275-.121.361-.349.395Z",
    transform: "translate(-3.243 -189.848)",
    fill: "#fee36a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140769",
    "data-name": "Path 140769",
    d: "M6.067,128.425a46.288,46.288,0,0,1,2.874-5.138c3.668-6.34,7.38-12.656,11.075-18.98a53.71,53.71,0,0,0,3.289,4.441c-1.593,1.507-2.892,3.274-4.34,4.909-2.143,2.42-4.211,4.907-6.316,7.361q-2.977,3.471-5.961,6.937C6.511,128.16,6.418,128.456,6.067,128.425Z",
    transform: "translate(-4.934 -84.829)",
    fill: "#ffdd7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140770",
    "data-name": "Path 140770",
    d: "M116.229,117.822c-.077.114-.216.181-.3.084-.115-.136.084-.165.148-.239Z",
    transform: "translate(-94.255 -95.696)",
    fill: "#fe8b06"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopperIcon);
export default __webpack_public_path__ + "static/media/PartyPopperIcon.4524b2144af44a5d2eaf528409d171f8.svg";
export { ForwardRef as ReactComponent };